var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95238 2.66667C3.11314 3.71581 1.90476 5.73105 1.90476 8C1.90476 9.20552 2.26224 10.384 2.932 11.3863C3.60175 12.3887 4.55369 13.1699 5.66745 13.6313C6.78121 14.0926 8.00676 14.2133 9.18912 13.9781C10.3715 13.7429 11.4576 13.1624 12.31 12.31C13.1624 11.4576 13.7429 10.3715 13.9781 9.18912C14.2133 8.00676 14.0926 6.78121 13.6313 5.66745C13.1699 4.55369 12.3887 3.60175 11.3863 2.932C10.384 2.26224 9.20552 1.90476 8 1.90476",
    stroke: "#FCFDFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95238 5.71428V2.66666H1.90476",
    stroke: "#FCFDFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.523ab278574da72bfda69a705524f4f2.svg";
export { ForwardRef as ReactComponent };